/**
 * Usuwa niepotrzebny początek błędu GraphQL
 *
 * @export
 * @param {string} errorMsg
 * @returns
 */
export function serverError(errorMsg: string) {
  if (errorMsg.includes('Network error')) {
    return 'Nie można połączyć się z serwerem. Sprawdź czy masz połączenie z internetem.';
  }
  return errorMsg.replace(/(Error: )?GraphQL error:/gi, '').trim();
}
